import VideoHeader from "./video/VideoHeader";
import OpenViduVideo from "./video/OpenViduVideo";

const VideoFrame = () => {
  return (
    <>
      <VideoHeader />
      <OpenViduVideo />
    </>
  );
};

export default VideoFrame;
